export default (date) => {
  const a = {
    'January': 'Января',
    'February': 'Февраля',
    'March': 'Марта',
    'April': 'Апреля',
    'May': 'Мая',
    'June': 'Июня',
    'July': 'Июля',
    'August': 'Августа',
    'September': 'Сентября',
    'October': 'Октября',
    'November': 'Ноября',
    'December': 'Декабря'
  }

  Object.entries(a).map((d) => {
    date = date.replace(d[0], d[1]);
  })
  return date;
}



// WEBPACK FOOTER //
// ./src/libs/date.js